import React, {Fragment} from 'react';
import Collapsible from 'react-collapsible';
import {collapsibleSettings} from '../../helpers/Helpers';
import Input from "../Fields/Input";
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";

const InputField = (props) => {
    const {
        input,
        label,
        placeholder,
        type,
        icon,
        meta: {
            touched,
            error
        },
        omitCollapsible,
        expanded,
        required,
        defaultValue,
        helpText,
    } = props;

    const content = (
        <Input
            input={input}
            label={label || null}
            error={touched && error ? error : null}
            icon={icon}
            type={type || 'text'}
            placeholder={placeholder}
            required={required}
            defaultValue={defaultValue}
            helpText={helpText}
        />
    );

    return (
        <Fragment>
            {omitCollapsible ? (
                <div>{content}</div>
            ) : (
                <Collapsible
                    {...collapsibleSettings}
                    trigger={<label className={classNamesPrefixed({"trigger__label":true})}>{label ? label : 'Input field'}</label>}
                    open={expanded}
                >
                    {content}
                </Collapsible>
            )}
        </Fragment>
    );
};

export default InputField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/InputField.js